module.exports = __webpack_public_path__ + "img/plus.5c259683.svg";